<script setup lang="ts">
import { computed } from "vue";

import PageWrapper from "@/common/components/PageWrapper.vue";
import type { LinkTab } from "@/common/types";
import { useCurrentUser } from "@/users/public/composables";

const { userHasPermission } = useCurrentUser();

definePage({
  meta: {
    auth: ["Kits.Read"],
  },
});

const breadcrumbs = [
  {
    label: "Mockup Management",
    to: "#",
  },
];

const tabs = computed(() => {
  const linkTabs: LinkTab[] = [];

  if (userHasPermission("Admin.Access")) {
    linkTabs.push({
      title: "Pending Approval",
      to: "/kits/management/pending",
    });
  }

  linkTabs.push(
    {
      title: "Incomplete",
      to: "/kits/management",
    },
    {
      title: "Completed",
      to: "/kits/management/completed",
    },
  );

  return linkTabs;
});
</script>

<template>
  <PageWrapper
    title="Mockup Management"
    :breadcrumb-links="breadcrumbs"
    :tabs="tabs"
  >
    <RouterView />
  </PageWrapper>
</template>
